import { api } from "@/lib/api";
import type { ScopedParams } from "./common";
import type { ChampionPickViewDto, SubmitChampionPickRequest } from "@/types/api";

export const championApi = {
  get: ({ leagueId, tournamentId }: ScopedParams) =>
    api.get<ChampionPickViewDto>("/api/champion-pick", { leagueId, tournamentId }),
  submit: (body: SubmitChampionPickRequest) => api.post<{ success: boolean }>("/api/champion-pick", body),
};
